/**
 * The container an exception belongs to, by link id. `workOrderContainerId` wins: a pre-join payload
 * can carry both, and the WO-scoped link matches the containers list this work order renders.
 */
export const resolveExceptionContainerLinkId = (exception: {
  workOrderContainerId?: string | null
  containerId?: string | null
}): string | undefined => exception.workOrderContainerId || exception.containerId || undefined
